module.exports = __webpack_public_path__ + "img/logo.4da32e14.png";